export const cacheKey = "/engagement/media_library_data" as const;
export const mediaLibraryTagsCacheKey = "/engagement/:app_group_id/media_library_tags" as const;
export const mediaLibraryTeamsCacheKey = "/engagement/:app_group_id/media_library_territories" as const;
export const mediaLibrarySourcesCacheKey = "/engagement/:app_group_id/media_library_sources" as const;
